module.exports = __webpack_public_path__ + "img/glassthicknessminus-167.45938c6e.svg";